import type { CSSProperties } from 'react'
import './fixer-hero.css'
import { useFixerContent } from '../hooks/i18n/usePageContent.js'

/** Shared fjord-unit plate — `/fixer` and `/ai-agency`. */
const HERO_IMAGE_SRC = '/fixer/hero-fjord-unit.webp'

export interface FixerHeroVisualProps {
  stageStyle?: CSSProperties | undefined
  imageStyle?: CSSProperties | undefined
  scrollLayerStyle?: CSSProperties | undefined
  reducedMotion?: boolean
}

export function FixerHeroVisual({
  stageStyle,
  imageStyle,
  scrollLayerStyle,
  reducedMotion = false,
}: FixerHeroVisualProps) {
  const heroAlt = useFixerContent().chrome.heroAlt
  return (
    <div className="fixer-hero-stage relative h-full min-h-[320px] w-full touch-pan-y">
      <div className="absolute inset-0 origin-center" style={stageStyle}>
        <div className="absolute inset-[-4%]" style={imageStyle}>
          <div className="fixer-hero-scroll-layer absolute inset-0" style={scrollLayerStyle}>
            <div className="fixer-hero-ken-burns absolute inset-0">
              <img
                ref={element => element?.setAttribute('fetchpriority', 'high')}
                src={HERO_IMAGE_SRC}
                alt={heroAlt}
                className="absolute inset-0 h-full w-full object-cover object-[18%_42%] md:object-[center_42%]"
                decoding="async"
                width={1672}
                height={941}
              />

              {!reducedMotion && (
                <>
                  <div className="fixer-hero-ambient pointer-events-none absolute inset-0" aria-hidden="true" />
                  <div className="fixer-hero-grain pointer-events-none absolute inset-0" aria-hidden="true" />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="fixer-hero-overlay pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="fixer-hero-vignette pointer-events-none absolute inset-0" aria-hidden="true" />
    </div>
  )
}
